"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var isString = function isString(obj) {
  return typeof obj === 'string';
};

var _default = isString;
exports["default"] = _default;